<template>
  <el-card>
    <div class="toolbar">
      <el-button type="success" @click="openCreate">新增玩法</el-button>
    </div>
    <el-table :data="list" v-loading="loading" border>
      <el-table-column prop="id" label="ID" width="70"></el-table-column>
      <el-table-column prop="name" label="名称" width="140"></el-table-column>
      <el-table-column prop="intro" label="简介"></el-table-column>
      <el-table-column label="发包金额" width="140">
        <template slot-scope="s">{{ s.row.minAmount }} ~ {{ s.row.maxAmount }}</template>
      </el-table-column>
      <el-table-column prop="leftoverTimeoutMinutes" label="尾包超时(分)" width="120"></el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="s">
          <el-button type="text" @click="openEdit(s.row)">编辑</el-button>
          <el-button type="text" @click="copy(s.row)">复制</el-button>
          <el-button type="text" style="color:#F56C6C" @click="remove(s.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top:12px"
      background
      layout="total,sizes,prev,pager,next"
      :total="total"
      :page-sizes="[10, 20, 50, 100, 200]"
      :page-size="size"
      :current-page.sync="page"
      @size-change="onSizeChange"
      @current-change="load"
    ></el-pagination>

    <el-dialog title="玩法配置" :visible.sync="dialog" width="760px">
      <el-form :model="form" label-width="130px" size="small">
        <el-form-item label="玩法名称"><el-input v-model="form.name"></el-input></el-form-item>
        <el-form-item label="简介"><el-input type="textarea" v-model="form.intro"></el-input></el-form-item>
        <el-form-item label="发包最小金额"><el-input-number v-model="form.minAmount" :min="0.01" :precision="2"></el-input-number></el-form-item>
        <el-form-item label="发包最大金额"><el-input-number v-model="form.maxAmount" :min="0.01" :precision="2"></el-input-number></el-form-item>
        <el-form-item label="尾包超时(分钟)"><el-input-number v-model="form.leftoverTimeoutMinutes" :min="1"></el-input-number></el-form-item>
        <el-form-item label="红包个数及赔付">
          <div v-for="(p, i) in packets" :key="i" style="margin-bottom:8px">
            个数 <el-input-number v-model="p.packetCount" :min="1" size="mini"></el-input-number>
            赔付 <el-input-number v-model="p.payoutPercent" :min="1" :precision="2" size="mini"></el-input-number> %
            <el-button type="text" @click="removePacket(i)">删除</el-button>
          </div>
          <el-button size="mini" @click="addPacket">增加一条</el-button>
        </el-form-item>
        <el-divider>抢包奖励</el-divider>
        <p class="reward-hint">填 0 表示无此项奖励，结算时不会发放</p>
        <el-row :gutter="12" class="reward-grid">
          <el-col :span="12"><el-form-item label="三位豹子"><el-input-number v-model="form.rewardSame3" :min="0" :precision="2"></el-input-number></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="四位豹子"><el-input-number v-model="form.rewardSame4" :min="0" :precision="2"></el-input-number></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="三位顺子"><el-input-number v-model="form.rewardStraight3" :min="0" :precision="2"></el-input-number></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="四位顺子"><el-input-number v-model="form.rewardStraight4" :min="0" :precision="2"></el-input-number></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="0.01奖励"><el-input-number v-model="form.rewardMin001" :min="0" :precision="2"></el-input-number></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="5.20奖励"><el-input-number v-model="form.reward520" :min="0" :precision="2"></el-input-number></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="13.14奖励"><el-input-number v-model="form.reward1314" :min="0" :precision="2"></el-input-number></el-form-item></el-col>
        </el-row>
        <el-divider>发包奖励</el-divider>
        <p class="reward-hint">填 0 表示无此项奖励，结算时不会发放</p>
        <el-row :gutter="12" class="reward-grid">
          <el-col :span="12"><el-form-item label="中1雷(%)"><el-input-number v-model="form.rewardMine1Percent" :min="0" :precision="2"></el-input-number></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="中3雷"><el-input-number v-model="form.rewardMine3" :min="0" :precision="2"></el-input-number></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="中4雷"><el-input-number v-model="form.rewardMine4" :min="0" :precision="2"></el-input-number></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="中5雷"><el-input-number v-model="form.rewardMine5" :min="0" :precision="2"></el-input-number></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="中6雷"><el-input-number v-model="form.rewardMine6" :min="0" :precision="2"></el-input-number></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="中7雷"><el-input-number v-model="form.rewardMine7" :min="0" :precision="2"></el-input-number></el-form-item></el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="dialog = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { rules as fetchRules, ruleDetail, saveRule, deleteRule, copyRule } from '../api'

const REWARD_KEYS = [
  'rewardSame3', 'rewardSame4', 'rewardStraight3', 'rewardStraight4',
  'rewardMin001', 'reward520', 'reward1314',
  'rewardMine1Percent', 'rewardMine3', 'rewardMine4',
  'rewardMine5', 'rewardMine6', 'rewardMine7'
]

function emptyRule() {
  return {
    id: null,
    name: '',
    intro: '',
    minAmount: 30,
    maxAmount: 200,
    leftoverTimeoutMinutes: 10,
    rewardSame3: 12.88,
    rewardSame4: 38.88,
    rewardStraight3: 8.88,
    rewardStraight4: 38.88,
    rewardMin001: 8.88,
    reward520: 28.88,
    reward1314: 18.88,
    rewardMine1Percent: 30,
    rewardMine3: 12.88,
    rewardMine4: 28.88,
    rewardMine5: 66.66,
    rewardMine6: 108.88,
    rewardMine7: 188.88
  }
}

function toSaveRule(rule) {
  const next = {
    id: rule.id,
    name: rule.name,
    intro: rule.intro,
    minAmount: rule.minAmount,
    maxAmount: rule.maxAmount,
    leftoverTimeoutMinutes: rule.leftoverTimeoutMinutes
  }
  REWARD_KEYS.forEach((key) => {
    const value = rule[key]
    next[key] = value === null || value === undefined || value === '' ? 0 : Number(value)
  })
  return next
}

export default {
  name: 'Rules',
  data() {
    return {
      loading: false,
      page: 1,
      size: 10,
      total: 0,
      list: [],
      dialog: false,
      form: emptyRule(),
      packets: [
        { packetCount: 5, payoutPercent: 200 },
        { packetCount: 7, payoutPercent: 160 }
      ]
    }
  },
  created() {
    this.load()
  },
  methods: {
    onSizeChange(val) {
      this.size = val
      this.page = 1
      this.load()
    },
    load() {
      this.loading = true
      fetchRules({ page: this.page, size: this.size }).then((data) => {
        this.list = data.records || []
        this.total = data.total || 0
      }).catch((e) => {
        this.$message.error(e.message)
      }).then(() => {
        this.loading = false
      })
    },
    openCreate() {
      this.form = emptyRule()
      this.packets = [
        { packetCount: 5, payoutPercent: 200 },
        { packetCount: 7, payoutPercent: 160 }
      ]
      this.dialog = true
    },
    openEdit(row) {
      ruleDetail(row.id).then((data) => {
        this.form = Object.assign(emptyRule(), data.rule)
        this.packets = data.packets && data.packets.length ? data.packets : [{ packetCount: 5, payoutPercent: 200 }]
        this.dialog = true
      }).catch((e) => {
        this.$message.error(e.message)
      })
    },
    addPacket() {
      this.packets.push({ packetCount: 5, payoutPercent: 200 })
    },
    removePacket(i) {
      this.packets.splice(i, 1)
    },
    save() {
      saveRule({ rule: toSaveRule(this.form), packets: this.packets }).then(() => {
        this.$message.success('保存成功')
        this.dialog = false
        this.load()
      }).catch((e) => {
        this.$message.error(e.message)
      })
    },
    copy(row) {
      this.$confirm('复制玩法「' + row.name + '」？副本不会绑定任何群聊。', '提示').then(() => {
        return copyRule(row.id)
      }).then(() => {
        this.$message.success('已复制')
        this.load()
      }).catch((e) => {
        if (e && e.message) this.$message.error(e.message)
      })
    },
    remove(row) {
      this.$confirm('确定删除玩法「' + row.name + '」吗？', '提示', { type: 'warning' }).then(() => {
        return deleteRule(row.id)
      }).then(() => {
        this.$message.success('已删除')
        this.load()
      }).catch((e) => {
        if (e && e.message) this.$message.error(e.message)
      })
    }
  }
}
</script>

<style scoped>
.reward-hint {
  margin: -4px 0 12px 0;
  color: #909399;
  font-size: 12px;
}
</style>
